import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { BillStatusEnum } from './bills.interface';

@Injectable({ providedIn: 'root' })
@Pipe({
  name: 'billStatusPipe'
})
export class BillStatusPipe implements PipeTransform {

  transform(value: string|null): string {
    switch(value) {
      case BillStatusEnum.BILLED: return 'Faturalandı';
      case BillStatusEnum.CANCEL: return 'İptal';
      case BillStatusEnum.APPROVE_CANCEL: return 'Onay Kaldırılma İptali'
      case BillStatusEnum.NOT_BILLED: return 'İşlem Bekliyor';
      default:return ""
    }
  }

}
